import React, { useContext } from 'react';
import ReactDOM from 'react-dom/client';
import App from './clients/pages/App';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import ScrollToTop from './clients/utils/ScrollToTop';
import reportWebVitals from './reportWebVitals';
import './clients/sass/index.scss';
import HotelList from './clients/pages/HotelList';
import Hotel from './clients/pages/Hotel';
import ResetPassword from './clients/pages/ResetPassword';
import Login from './clients/pages/Login';
import Admin from './adminHotel/pages/Admin';
import Destination from './clients/pages/Destination';
import CreateHotel from './adminHotel/pages/Hotel/CreateHotel';
import { SearchContextProvider } from './clients/utils/SearchContext';
import { AuthContext, AuthContextProvider } from './clients/utils/AuthContext';
import Signup from './clients/pages/Signup';
import LoginAdmin from './adminHotel/pages/LoginAdmin';
import DevAdmin from './devAdmin/pages/Admin';
import EmailVer from './clients/pages/EmailVer';
import Contact from './clients/pages/Contact';
import LoginB from './clients/pages/LoginB_temp';
import RegisterHotel from './clients/pages/RegisterHotel';
import { createTheme, ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import ForgotPassword from './clients/pages/ForgotPassword';
import "./index.css";
import { Toaster } from 'react-hot-toast';
import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import CheckOutPage from './clients/pages/CheckOut/CheckOutPage';
import Confirmation from './clients/pages/CheckOut/Confirmation';
import MyReservations from './clients/pages/User/MyReservations';
import { AuthAdminContext, AuthAdminContextProvider } from './clients/utils/AuthAdminContext';
import Profile from './clients/pages/User/Profil';
import ConfirmReservation from './clients/pages/CheckOut/ConfirmReservation';
// 🆕 ANNULATION AVANT VERSEMENT — lien du mail d'instructions de paiement
import AnnulationVersement from './clients/pages/CheckOut/AnnulationVersement';
import ReservationPending from './clients/pages/CheckOut/Pending';
import { HelmetProvider } from 'react-helmet-async';
import AdminResetPassword from './adminHotel/pages/AdminResetPassword';
import Settings from './clients/pages/User/Settings';
import Favorites from './clients/pages/User/Favorites';
import AgencyLogin from './agency/AgencyLogin';
import Agency from './agency/Agency';
import { AgencyContext, AgencyContextProvider } from './clients/utils/AgencyContext';
import { OrganizationContext, OrganizationContextProvider } from './clients/utils/OrganizationContext';
import OrganizationLogin from './organization/OrganizationLogin';
import Organization from './organization/Organization';
import OrganizationRequest from './organization/OrganizationRequest';
import OrganizationDecline from './organization/OrganizationDecline';
import OrganizationActivate from './organization/OrganizationActivate';
import MissionLanding from './organization/MissionLanding';
import SuperAdminOrganizations from './superadmin/SuperAdminOrganizations';
import { SuperAdminContextProvider } from "./superadmin/SuperAdminContext";
import ProtectedSuperAdminRoute from "./superadmin/ProtectedSuperAdminRoute";
import SuperAdminLogin from "./superadmin/SuperAdminLogin";
import SuperAdmin from "./superadmin/SuperAdmin";
import SuperAdminDashboard from "./superadmin/SuperAdminDashboard";
import SuperAdminHotels from "./superadmin/SuperAdminHotels";
import SuperAdminReservations from "./superadmin/SuperAdminReservations";
import SuperAdminUsers from "./superadmin/SuperAdminUsers";
import SuperAdminPlatform from "./superadmin/SuperAdminPlatform";
import VisionMode from "./superadmin/VisionMode";
import ActivateAccount from "./superadmin/ActivateAccount";
import RegisterHotel2 from "./superadmin/RegisterHotel";
import CookiesBanner from "./components/CookiesBanner";
import PrivacyPolicy from "./clients/pages/PrivacyPolicy";
import About from './clients/pages/About';
import SuperAdminConnectivity from './superadmin/SuperAdminConnectivity';
import CMTestPage from "./clients/pages/CMTestPage";  // adapte le chemin


const root = ReactDOM.createRoot(document.getElementById('root'));

function ProtectedUserRoute({ Component }) {
  const { user } = useContext(AuthContext);

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <Component />;
}

function ProtectedAdminRoute({ Component }) {
  const { admin, loading } = useContext(AuthAdminContext);

  if (loading) return null;

  if (!admin) {
    return <Navigate to="/admin" replace />;
  }

  return <Component />;
}

function ProtectedOrganizationRoute({ Component }) {
  const { organization, loading } = useContext(OrganizationContext);

  if (loading) return null;

  if (!organization) {
    return <Navigate to="/organisation/connexion" replace />;
  }

  return <Component />;
}

function ProtectedAgencyRoute({ Component }) {
  const { agency, loading } = useContext(AgencyContext);

  if (loading) return null;

  if (!agency) {
    return <Navigate to="/agency/login" replace />;
  }

  return <Component />;
}
/* MUI parse les couleurs en JS : il ne comprend pas var().
   On relit la variable CSS et on la reformate pour lui.
   Source de vérité unique = index.css. */
const brandRgb = getComputedStyle(document.documentElement)
  .getPropertyValue("--k-green-rgb").trim();
const BRAND = brandRgb ? `rgb(${brandRgb.split(/\s+/).join(", ")})` : "#3A9D23";

const theme = createTheme({
  palette: {
    primary: { main: BRAND },
  },
});

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <ScrollToTop />

      <AuthContextProvider>
        <AuthAdminContextProvider>
          <AgencyContextProvider>
            <OrganizationContextProvider>
            <SearchContextProvider>

              <ThemeProvider theme={theme}>
                <MantineProvider
                  theme={{
                    primaryColor: "komoro",
                    primaryShade: 8,
                    colors: {
                      komoro: [
                        "#edf7f4",
                        "#dbf0e9",
                        "#bbe2d4",
                        "#89dcbf",
                        "#5acea5",
                        "#36b588",
                        "#2a8d6b",
                        "#206a50",
                        "#174d3a",
                        "#0f3326"
                      ]
                    },
                    defaultRadius: "md",
                    fontFamily: "Inter, sans-serif"
                  }}
                >

                  <CssBaseline />
                  <Toaster position="top-right" />

                  <Routes>
                    <Route path="/" element={<App />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/hotels" element={<HotelList />} />
                    <Route path="/destinations" element={<Destination />} />
                    <Route path="/hotel/slug/:slug" element={<Hotel />} />
                    <Route path="/register-hotel" element={<RegisterHotel />} />
                    <Route path="/checkout" element={<CheckOutPage />} />
                    <Route path="/confirmation/:id" element={<Confirmation />} />
                    <Route path="/reservation-pending" element={<ReservationPending />} />
                    <Route path="/confirm-reservation" element={<ConfirmReservation />} />
                    <Route path="/annulation/:token" element={<AnnulationVersement />} />
                    <Route path="/my-reservations" element={<MyReservations />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/favorites" element={<Favorites />} />
                    <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
                    <Route path="/about" element={<About />} />


                    <Route path="/login" element={<Login />} />
                    <Route path="/login/:userId" element={<LoginB />} />

                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password/:token" element={<ResetPassword />} />

                    <Route path="/admin" element={<LoginAdmin />} />
                    <Route path="/admin-reset/:token" element={<AdminResetPassword />} />

                    <Route path="/agency/login" element={<AgencyLogin />} />
                    <Route path="/agency/backoffice/:hotelId" element={<ProtectedAgencyRoute Component={Admin} />} />
                    <Route path="/agency/*" element={<ProtectedAgencyRoute Component={Agency} />} />

                    {/* ── ESPACE ORGANISATION ── */}
                    <Route path="/organisation/connexion" element={<OrganizationLogin />} />
                    <Route path="/organisation/demande" element={<OrganizationRequest />} />
                    <Route path="/organisation/retrait/:token" element={<OrganizationDecline />} />
                    <Route path="/organisation/activation/:token" element={<OrganizationActivate />} />
                    <Route path="/mission/:token" element={<MissionLanding />} />
                    <Route path="/organisation/*" element={<ProtectedOrganizationRoute Component={Organization} />} />

                    <Route path="/signup" element={<Signup />} />
                    <Route path="/signup/emailverification" element={<EmailVer />} />

                    <Route path="/admin/:userId" element={<ProtectedAdminRoute Component={CreateHotel} />} />
                    <Route path="/admin/:userId/:hotelId" element={<ProtectedAdminRoute Component={Admin} />} />
                    <Route path="/devAdmin/:id" element={<ProtectedAdminRoute Component={DevAdmin} />} />

                    <Route path="/activate/:token" element={<ActivateAccount />} />
                    <Route path="/inscrire-mon-hotel" element={<RegisterHotel2 />} />

                    {/* ── LOGIN SUPER ADMIN (hors wrapper protégé) ── */}
                    <Route
                      path="/superadmin/login"
                      element={
                        <SuperAdminContextProvider>
                          <SuperAdminLogin />
                        </SuperAdminContextProvider>
                      }
                    />

                    {/* ── MODE VISION (protégé, hors layout sidebar) ── */}
                    <Route
                      path="/superadmin/vision/:hotelId"
                      element={
                        <SuperAdminContextProvider>
                          <ProtectedSuperAdminRoute>
                            <VisionMode />
                          </ProtectedSuperAdminRoute>
                        </SuperAdminContextProvider>
                      }
                    />
                    <Route path="/cm-test" element={<CMTestPage />} />


                    {/* ── ESPACE SUPER ADMIN (layout + routes enfants) ── */}
                    <Route
                      path="/superadmin"
                      element={
                        <SuperAdminContextProvider>
                          <ProtectedSuperAdminRoute>
                            <SuperAdmin />
                          </ProtectedSuperAdminRoute>
                        </SuperAdminContextProvider>
                      }
                    >
                      <Route index element={<SuperAdminDashboard />} />
                      <Route path="hotels" element={<SuperAdminHotels />} />
                      <Route path="reservations" element={<SuperAdminReservations />} />
                      <Route path="users" element={<SuperAdminUsers />} />
                      <Route path="platform" element={<SuperAdminPlatform />} />
                      <Route path="connectivity" element={<SuperAdminConnectivity />} />
                      <Route path="organizations" element={<SuperAdminOrganizations />} />
                      // ...
                    </Route>

                  </Routes>
                  <CookiesBanner lang="fr" />

                </MantineProvider>
              </ThemeProvider>

            </SearchContextProvider>
            </OrganizationContextProvider>
          </AgencyContextProvider>
        </AuthAdminContextProvider>
      </AuthContextProvider>

    </BrowserRouter>
  </HelmetProvider>
);

reportWebVitals();